var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "manual-checkin-form"
  }, [_c('h3', {
    staticClass: "form-title"
  }, [_vm._v("手動報到")]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("姓名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.name,
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入姓名"
    },
    domProps: {
      "value": _vm.formData.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("手機")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.phone,
      expression: "formData.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "placeholder": "請輸入手機號碼"
    },
    domProps: {
      "value": _vm.formData.phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "phone", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "s-btn s-btn-secondary action-button",
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(" 取消 ")]), _c('button', {
    staticClass: "s-btn s-btn-primary action-button",
    attrs: {
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" 確認 ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }